<template>
  <div>
    <b-card>
      <div slot="header">Informações da Arrecadação
        <b-badge style="font-weight: normal" variant="mute" class="float-right small">(<span style="color: #D9001B">*</span>) Obrigatório</b-badge>
      </div>
      <b-overlay :show="carregando">
      <b-row sm="12" md="12">
        <b-col sm="6" md="6">
          <label class="required">Categoria</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <multiselect
              class="border-input-normal"
              id="codCategoria"
              name="categoria"              
              v-model="form.codCategoria"
              :options="categoria"
              label="text"
              track-by="value"
              open-direction="bottom"
              :aria-describedby="ariaDescribedby"
              placeholder="Digite e selecione a opção desejada"
              selectLabel=""
              selectGroupLabel=""
              selectedLabel="Selecionado"
              deselectLabel=""
              deselectGroupLabel=""
              :disabled="disabled"
              @input="mudarCategoria"
            >
              <template #noResult>
                Nenhuma opção encontrada. Tente outro termo.
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row sm="12" md="12">
        <b-col v-show="mostraComboArrecadacao && isPedidoCodigoArrecadacao" sm="6" md="6">
          <label class="required">Código de Arrecadação</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <multiselect
              class="border-input-normal"
              id="codArrecadacao"
              ref="codArrecadacao"
              name="codArrecadacao"
              v-model="form.codArrecadacao"
              :options="codArrecadacao"
              label="text"
              track-by="value"
              open-direction="bottom"
              :searchable="true"
              :aria-describedby="ariaDescribedby"
              placeholder="Digite e selecione a opção desejada"
              selectLabel=""
              selectGroupLabel=""
              selectedLabel="Selecionado"
              deselectLabel=""
              deselectGroupLabel=""
              :disabled="disabled"
              @input="mudarCodArrecadacao"
            >
              <template #noResult>
                Nenhuma opção encontrada. Tente outro termo.
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row sm="12" md="12">
       <b-col v-show="mostraInstituicao" sm="6" md="6">
          <label class="required">Instituição</label>
          <b-form-group v-slot="{ ariaDescribedby }">
            <multiselect
              class="border-input-normal"
              id="codInstituicao"
              name="codInstituicao"
              v-model="form.codInstituicao"
              :options="instituicao"
              label="text"
              track-by="value"
              :searchable="true"
              :aria-describedby="ariaDescribedby"
              placeholder="Digite e selecione a opção desejada"
              selectLabel=""
              selectGroupLabel=""
              selectedLabel="Selecionado"
              deselectLabel=""
              deselectGroupLabel=""
              :disabled="disabled">
              <template #noResult>
                Nenhuma opção encontrada. Tente outro termo.
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary"></b-spinner>
          <p><b>{{tituloOverlay}}</b></p>
        </div>
      </template>
      </b-overlay>
      <div slot="footer">
        <div class="center-xy">
          <b-button class="mr-1" variant="primary" v-if="!habilitaNovaConsulta" :disabled="!habilitaConsulta || disabled" @click="consultar()"
            ><i class="fas fa-arrow-right"></i> Avançar</b-button>
          <b-button class="mr-1" variant="secondary" @click="novaEmissao()" :disabled="carregandoRoot"
            ><i class="fas fa-eraser"></i> Limpar</b-button>
        </div>
      </div>
    </b-card>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions, mapState, mapMutations } from 'vuex'
import mixinOverlay from '@/mixins/overlay.js'
import mixinMultiselect from '@/mixins/multiselectMixin.js'
import store from '@/store'

export default {  
  components: {
    Multiselect
  },
  mixins: [mixinOverlay, mixinMultiselect],
  props: {
    disabled: Boolean,
    habilitaNovaConsulta: Boolean,
    carregandoRoot: Boolean,
  },
  data () {
    return {      
      form: this.getForm(),
      reCaptchaToken: null
    }
  },
  async created() {
    try {
      this.setMesagemCarregando('Carregando.')
      await this.pesquisarCategoria()
      window.thizEGP = this
    } catch(e) {
      // ...
    } finally {
      this.resetCarregando()
    }
  },
  async mounted() {
    try {
      this.novaEmissao();
    } catch(e) {
      console.log(e)
    }
  },
  computed: {
    ...mapState('emitirguia',
    [
      'categoria',
      'codArrecadacao',
      'instituicao'
    ]),
    mostraComboArrecadacao() {
      return this.codArrecadacao.length
    },
    mostraInstituicao() {
      return ((this.instituicao.length > 1) && (this.form.codArrecadacao?.value != ''))
    },
    habilitaConsulta() {
      return (
        (this.form.codCategoria?.value && 
         this.form.codCategoria?.pedirCodigo == 2 && 
         this.form.codInstituicao?.value) || 
        (this.form.codCategoria?.value && 
         this.form.codCategoria?.pedirCodigo == 1 && 
         this.form.codInstituicao?.value && 
         this.form.codArrecadacao?.value))
    },
    isPedidoCodigoArrecadacao() {
      return this.form.codCategoria?.pedirCodigo != 2
    }
  },
  methods: {
    ...mapActions('emitirguia',
    [
      'pesquisarCategoria',
      'pesquisarCodArrecadacao',
      'arrecadacaoPorCodigo',
      'pesquisarInstituicao',
      'pesquisarInstituicaoPorArrecadacao'
    ]),
    ...mapMutations('emitirguia',
    [
      'setCodArrecadacao',
      'setInstituicao'
    ]),
    getForm() {
      return {
        codCategoria: null,
        codArrecadacao: null,
        codInstituicao: null,
      }
    },
    novaEmissao() {
      this.resetarScrollBarMultiselect()
      store.dispatch('message/resetMessages')
      this.form = this.getForm()
      this.setCodArrecadacao([])
      this.setInstituicao([])
      this.$emit('novaEmissao')
    },
    consultar () {
      this.$emit('carregarPasso', {
        cdUga: this.form.codInstituicao?.value,
        cdArrecadacao: this.form.codArrecadacao?.value,
        cdCategoria: this.form.codCategoria?.value,
        reCaptchaToken: this.reCaptchaToken
      })
    },
    async mudarCategoria() {
      this.form.codArrecadacao = null
      this.form.codInstituicao = null
      this.setCodArrecadacao([])
      this.setInstituicao([])
      try  {        
        this.setMesagemCarregando('Carregando.')
        await this.arrecadacaoPorCodigo(this.form.codCategoria.value)
        await this.pesquisarInstituicao(this.form.codCategoria.value)
        if(this.instituicao.length == 1) {
          this.form.codInstituicao = this.instituicao[0]
        }
      }
      catch(e) {
        // ...
      } finally {
        this.resetCarregando()
      }
    },
    async mudarCodArrecadacao() {
      this.form.codInstituicao = null
      this.setInstituicao([])
      try {
        this.setMesagemCarregando('Carregando.')
        await this.pesquisarInstituicaoPorArrecadacao(this.form.codArrecadacao.value)
        if(this.instituicao.length == 1) {
          this.form.codInstituicao = this.instituicao[0]
        }
      } catch(e) {
        // ...
      } finally {
        this.resetCarregando()
      }
    },
  }
}
</script>
